module.exports = __webpack_public_path__ + "img/icon-user-active.657b2687.svg";